import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "next", "previous", "track"]
  static values = { visibleItems: { type: Number, default: 4 } }

  connect() {
    this.index = 0
    this.update()
    this.element.dataset.productThumbnailsReady = "true"
  }

  disconnect() {
    delete this.element.dataset.productThumbnailsReady
  }

  next() {
    this.goTo(this.index + 1)
  }

  previous() {
    this.goTo(this.index - 1)
  }

  resize() {
    this.goTo(Math.min(this.index, this.maximumIndex), false)
  }

  goTo(index, smooth = true) {
    this.index = Math.max(0, Math.min(Number(index), this.maximumIndex))
    this.trackTarget.scrollTo({
      left: this.index * this.itemWidth,
      behavior: smooth ? this.scrollBehavior : "auto"
    })
    this.update()
  }

  update() {
    if (this.hasPreviousTarget) this.previousTarget.disabled = this.index === 0
    if (this.hasNextTarget) this.nextTarget.disabled = this.index === this.maximumIndex
    this.element.dataset.thumbnailIndex = this.index.toString()
  }

  get itemWidth() {
    return this.trackTarget.clientWidth / this.visibleItemsValue
  }

  get maximumIndex() {
    return Math.max(this.itemTargets.length - this.visibleItemsValue, 0)
  }

  get scrollBehavior() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
  }
}
